// extracted by mini-css-extract-plugin
export var editButton = "_qg-0";